import { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { bootstrapAuthenticatedSession } from "../../services/authService";
import { handleApiError } from "./util";
import {
  consumeOrgSwitchNavigation,
  shouldBootstrapDashboardEntry,
  skipDashboardBootstrapForRuntime,
} from "./utils/authSessionState";

const HomeBootstrapGate = () => {
  const { loading: authLoading, login, isAuthenticated } = useAuth();
  const loginRef = useRef(login);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    loginRef.current = login;
  }, [login]);

  useEffect(() => {
    if (authLoading) return;

    let isMounted = true;

    const resolveHomeEntry = async () => {
      try {
        if (consumeOrgSwitchNavigation()) {
          skipDashboardBootstrapForRuntime();
          if (isMounted) setIsReady(true);
          return;
        }

        if (!shouldBootstrapDashboardEntry()) {
          if (isMounted) setIsReady(true);
          return;
        }

        const response = await bootstrapAuthenticatedSession();

        if (response) {
          loginRef.current(response, {
            resetRefreshClock: !isAuthenticated,
          });
        }

        if (isMounted) setIsReady(true);
      } catch (error) {
        console.error("Error bootstrapping home entry:", error);
        handleApiError(error, {
          showModal: false,
          showButton: false,
        });
      }
    };

    void resolveHomeEntry();

    return () => {
      isMounted = false;
    };
  }, [authLoading, isAuthenticated]);

  if (authLoading || !isReady) {
    return <div>Loading...</div>;
  }

  return <Outlet />;
};

export default HomeBootstrapGate;
